import React from "react";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

interface ShowcasePageTitleProps {
  title: string;
  subtitle?: string;
}

export const ShowcasePageTitle = (props: ShowcasePageTitleProps) => {
  const { title, subtitle } = props;

  return (
    <Container>
      <Typography variant="h6" color="textPrimary">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="textSecondary">
          {subtitle}
        </Typography>
      )}
    </Container>
  );
};
